import {Label, LabelSmallRegular, TextMedium} from '@hm/fundamental'
import moment from 'moment'
import {useTranslation} from 'react-i18next'

interface StaticPartDetailLabelProps {
  partName: string
  shutdownName?: string
  interventionDate?: string
}

export const StaticPartDetailLabel: React.FC<StaticPartDetailLabelProps> = ({
  shutdownName,
  partName,
  interventionDate
}) => {
  const {t} = useTranslation()
  const title = shutdownName ? shutdownName : t('staticParts.detail')
  return (
    <div className="flex flex-col">
      {interventionDate && (
        <LabelSmallRegular>{moment(interventionDate).format('DD.MM.YYYY')}</LabelSmallRegular>
      )}
      <Label title={title} inverted data-cy="static_part_detail_label">
        <TextMedium>{partName}</TextMedium>
      </Label>
    </div>
  )
}
